window.startTooltips = ->
  $("[data-toggle=tooltip]").tooltip().click (e) ->
    e.preventDefault()
    $(this).tooltip('toggle')

  $("[data-toggle=popover]").popover().click (e) ->
    e.preventDefault()
